import { toPng, getFontEmbedCSS } from "html-to-image";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const MAX_SIDE = 1400;

export const compressImage = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = reject;
      img.onload = () => {
        const ratio = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * ratio);
        canvas.height = Math.round(img.height * ratio);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        const png = file.type === "image/png" || file.type === "image/webp";
        resolve(canvas.toDataURL(png ? "image/png" : "image/jpeg", 0.92));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });

let fontCSS = null;
const options = async (node) => {
  if (fontCSS === null) fontCSS = await getFontEmbedCSS(node).catch(() => "");
  return { width: 1080, height: 1920, pixelRatio: 1, fontEmbedCSS: fontCSS, includeQueryParams: true, style: { transform: "none" } };
};

export const renderPng = async (node) => toPng(node, await options(node));

export const downloadPng = async (node, filename) => saveAs(await renderPng(node), filename);

export const downloadZip = async (items, zipName, onProgress) => {
  const zip = new JSZip();
  for (let i = 0; i < items.length; i += 1) {
    const url = await renderPng(items[i].node);
    zip.file(items[i].filename, url.split(",")[1], { base64: true });
    onProgress?.(i + 1, items.length);
  }
  saveAs(await zip.generateAsync({ type: "blob" }), zipName);
};

export const slug = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_|_$/g, "");
